var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-container",
    { attrs: { fluid: "" } },
    [
      _c("admin-preloader", { attrs: { show: _vm.loading } }),
      _vm._v(" "),
      _c("admin-breadcrumb", { attrs: { name: "METRC Items" } }),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "admin-panel",
                {
                  attrs: { title: "Items", "with-footer": "" },
                  scopedSlots: _vm._u([
                    {
                      key: "header-right",
                      fn: function () {
                        return [
                          _c(
                            "div",
                            { staticClass: "mt-n2 d-flex flex-wrap" },
                            [
                              _c("b-form-input", {
                                staticClass: "w-auto mr-2 mt-2",
                                attrs: { placeholder: "Item Name" },
                                model: {
                                  value: _vm.filters.item_name,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.filters, "item_name", $$v)
                                  },
                                  expression: "filters.item_name",
                                },
                              }),
                              _vm._v(" "),
                              _c("b-form-input", {
                                staticClass: "w-auto mr-2 mt-2",
                                attrs: { placeholder: "Company Name" },
                                model: {
                                  value: _vm.filters.company_name,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.filters, "company_name", $$v)
                                  },
                                  expression: "filters.company_name",
                                },
                              }),
                              _vm._v(" "),
                              _c("b-form-input", {
                                staticClass: "w-auto mr-2 mt-2",
                                attrs: { placeholder: "License Number" },
                                model: {
                                  value: _vm.filters.license_number,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.filters, "license_number", $$v)
                                  },
                                  expression: "filters.license_number",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "footer",
                      fn: function () {
                        return [
                          _c("b-pagination", {
                            staticClass: "admin-pagination mb-0",
                            attrs: {
                              "total-rows": _vm.total_in_pages,
                              "per-page": _vm.per_page,
                              align: "center",
                            },
                            on: { change: _vm.loadItems },
                            model: {
                              value: _vm.page,
                              callback: function ($$v) {
                                _vm.page = $$v
                              },
                              expression: "page",
                            },
                          }),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [_c("admin-items-table", { attrs: { items: _vm.items } })],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }